import { MarketOutcome } from '../../enums';
import { GameContext, ScopeCompletedResolver } from '../../interfaces';
import { extractSelection } from '../parse-market.utils';

export const golfScopeResolver: ScopeCompletedResolver = (_period, { isCompleted }) => {
	return isCompleted;
};

export const golfTimeProgressResolver = () => null;

/**
 * Golf moneyline resolver — uses "Will " prefix (no "the" before player names).
 */
export const resolveGolfMoneyline = (q: string, gc: GameContext): [MarketOutcome] => {
	if (!gc.isCompleted) {
		return [MarketOutcome.Pending];
	}

	const playerName = extractSelection(q, 'Will ', ['win']);

	const isHome = playerName === gc.homeTeam;
	const homeWon = gc.homeScore < gc.awayScore; // lower score wins in golf

	if (gc.homeScore === gc.awayScore) {
		// Round bets: tie = push (Lost for both sides, no tiebreaker).
		// Overall Moneyline: stays Pending — playoff will resolve it.
		const isRoundBet = q.includes('round matchup');
		return [isRoundBet ? MarketOutcome.Lost : MarketOutcome.Pending];
	}

	return [isHome === homeWon ? MarketOutcome.Won : MarketOutcome.Lost];
};
